import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "../../revvComponents";

const NotesHeader = ({ addNote, updateToolPaneData, isSharedDocument }) => (
  <div className="notes-header">
    <span
      data-test="notesheader-right-pane-title"
      className="note-right-pane-title">
      Notes
    </span>

    <Button
      type="five"
      data-test="notesheader-add-new-note-button"
      // className="revv-btn-secondary-sm"
      onMouseDown={() => addNote()}>
      Add new note
    </Button>

    {isSharedDocument && (
      <span className="recipient-side-notetab-close-btn">
        <FontAwesomeIcon
          onClick={() => updateToolPaneData(false, "")}
          onKeyDown={() => {}}
          role="button"
          tabIndex="0"
          icon={["far", "times-circle"]}
          className=""
        />
      </span>
    )}
  </div>
);

export default NotesHeader;
